/* Länskartan på SGU:s öppna data — ritar SVG:n och kopplar ihop parameterväljare,
   karta, söklista, faktakort och HTML-tabellen.

   Datan ligger i assets/svp-lanskarta-sgu-data.js (window.SVP_LANSKARTA_SGU),
   genererad av scripts/bygg_lanskarta_sgu.py.

   TABELLEN I HTML:EN ÄR SANNINGEN, inte den här filen. Allt kartan visar står
   redan i snippets/svp-lanskarta-sgu-tabell.liquid, så en besökare utan
   JavaScript och en sökmotor ser samma siffror. Går den här filen sönder ska
   sidan fortfarande vara läsbar — därför avbryter vi tyst om datan saknas i
   stället för att tömma ytan.

   ⛔ ETT LÄN UTAN `andel` FÖR DEN VALDA PARAMETERN har för tunt underlag och
   får ingen siffra, någonstans i den här filen. Datafilen innehåller inte ens
   talet — bara `n` och `over`. Hittar du på ett fallback-värde här, eller
   räknar `over/n` på egen hand, återinför du precis det generatorns tröskel
   tog bort. Räkna ALDRIG en andel i den här filen.

   ⛔ ANTALEN FÅR SKRIVAS UT HÄR, tvärtemot den gamla kartans renderare. De är
   SGU:s provantal, inte vår analysvolym. Det var vår volym den gamla regeln
   skyddade. Flytta inte över den utan att läsa generatorns huvudkommentar.

   ⭐ FÄRGSKALAN ÄR ABSOLUT OCH DELAS AV ALLA NIO PARAMETRARNA — med flit.
   En skala som sträcktes om per parameter hade gett uran (2,0 % i riket) samma
   mörka toppfärg som pH (24,7 %), och kartan hade då sett lika alarmerande ut
   för ett ämne som nästan aldrig överskrids. Hinkarna nedan är fasta, så en
   färg betyder samma sak oavsett vilken parameter man tittar på och mellan två
   besök. Att uran blir nästan enfärgat ljust är ett korrekt svar, inte ett
   designfel. */
(function () {
  'use strict';
  var D = window.SVP_LANSKARTA_SGU;
  var yta = document.getElementById('svp-sgu-yta');
  if (!D || !D.lan || !D.lan.length || !D.parametrar || !D.parametrar.length || !yta) return;

  var NS = 'http://www.w3.org/2000/svg';
  var svg = document.getElementById('svp-sgu-svg');
  var gLan = document.getElementById('svp-sgu-lan');
  var gEtiketter = document.getElementById('svp-sgu-etiketter');
  var kort = document.getElementById('svp-sgu-kort');
  var valjare = document.getElementById('svp-sgu-valjare');
  var riktrad = document.getElementById('svp-sgu-riktvarde');
  var sok = document.getElementById('svp-sgu-sok');
  var traffar = document.getElementById('svp-sgu-traffar');
  if (!svg || !gLan || !kort || !valjare) return;

  svg.setAttribute('viewBox', '0 0 ' + D.bredd + ' ' + D.hojd);

  // Fasta hinkar, se filhuvudet. Gränserna är valda så att de fyra ämnena med
  // låga rikssiffror (klorid 2,6, arsenik 2,5, uran 2,0, sulfat 3,1) hamnar i
  // de två ljusa stegen medan pH (24,7), järn (18,9) och mangan (13,8) fyller
  // de mörka — alltså så att skalan faktiskt skiljer parametrarna åt.
  var HINKAR = [2, 5, 10, 25];
  function band(andel) {
    for (var i = 0; i < HINKAR.length; i++) if (andel < HINKAR[i]) return 'b' + (i + 1);
    return 'b5';
  }
  // ALLTID en decimal. JSON ger heltalet 3 för en andel på 3,0, och ett naivt
  // String(v) skrev då "3 %" i kortet medan den genererade tabellen skrev
  // "3,0 %" — samma tal, två format, bredvid varandra i samma kolumn. Med
  // tabular-nums syns det dessutom direkt att decimalerna inte står i linje.
  // toFixed(1) rundar inte om något: generatorn har redan rundat till en
  // decimal, det här återställer bara den som JSON tappade.
  function pct(v) { return Number(v).toFixed(1).replace('.', ',') + ' %'; }

  // Tusengruppering med HÅRT mellanslag, samma form som generatorn skriver i
  // meningarna. Utan den stod "Brunnsprov 1181" i kortet medan meningen längre
  // ner på samma sida sa "1 181 prov" – samma tal i två format.
  function antal(v) {
    return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
  function harSiffra(v) { return v && typeof v.andel === 'number'; }

  var aktiv = D.parametrar[0].namn;
  var valt = null;
  var former = {};
  var etiketter = {};

  function varde(l, p) { return (l.varden && l.varden[p]) || { n: 0, over: 0 }; }
  function hitta(namn) {
    for (var i = 0; i < D.lan.length; i++) if (D.lan[i].n === namn) return D.lan[i];
    return null;
  }
  function parameter(namn) {
    for (var i = 0; i < D.parametrar.length; i++) {
      if (D.parametrar[i].namn === namn) return D.parametrar[i];
    }
    return D.parametrar[0];
  }
  function lanMed(p) {
    var k = 0;
    D.lan.forEach(function (l) { if (harSiffra(varde(l, p))) k++; });
    return k;
  }

  // ── Parameterväljaren ───────────────────────────────────────────────────────
  // Knappar, inte en <select>: alla nio ska gå att se samtidigt, och
  // täckningen (hur många län som har en siffra) ska stå på knappen. Uran har
  // bara 8 av 21 län, och den som väljer uran ska veta det INNAN kartan blir
  // mest rastrerad — annars ser sidan trasig ut.
  // Grupperade efter vad anmärkningen BETYDER — hälsa, eller smak/teknik.
  // ⛔ GRUPPEN KOMMER UR DATAN (`p.grupp`), som generatorn skriver ur
  // PARAMETRAR. Skriv ingen egen lista här: den glider isär från generatorns
  // vid första nya parametern, och då hamnar ett ämne i fel fack utan att
  // något ser trasigt ut. Saknar datan grupp ritas allt i en grupp, så en
  // äldre datafil inte tömmer väljaren.
  var grupper = [];
  D.parametrar.forEach(function (p) {
    var g = p.grupp || '';
    if (grupper.indexOf(g) < 0) grupper.push(g);
  });
  grupper.forEach(function (g) {
    var box = document.createElement('div');
    box.className = 'sgu-pgrupp';
    var inner = '';
    if (g) inner += '<span>' + g + '</span>';
    inner += '<div>';
    D.parametrar.forEach(function (p) {
      if ((p.grupp || '') !== g) return;
      inner += '<button type="button" class="sgu-param" data-param="' + p.namn + '">' +
        '<strong>' + p.namn + '</strong><span>' + lanMed(p.namn) + ' av 21 län</span></button>';
    });
    inner += '</div>';
    box.innerHTML = inner;
    valjare.appendChild(box);
  });
  valjare.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-param]');
    if (b) valjParameter(b.getAttribute('data-param'));
  });

  function valjParameter(namn) {
    aktiv = parameter(namn).namn;
    Array.prototype.forEach.call(valjare.querySelectorAll('button[data-param]'), function (b) {
      var pa = b.getAttribute('data-param') === aktiv;
      b.classList.toggle('vald', pa);
      b.setAttribute('aria-pressed', pa ? 'true' : 'false');
    });
    mala();
    markeraKolumn();
    ritaTopp();
    ritaStaplar();
    // Kortet visar den valda parameterns siffra. Ritas det inte om säger
    // kortet fortfarande järn medan kartan visar uran.
    if (valt) valj(valt); else tomtKort();
    // Samma sak för hover-utläsningen: byter man parameter med musen kvar
    // över ett län står den gamla siffran kvar i tooltipen.
    if (hovrat) hovra(hovrat);
  }

  function mala() {
    var p = parameter(aktiv);
    D.lan.forEach(function (l) {
      var v = varde(l, aktiv);
      var sti = former[l.n].querySelector('path');
      sti.setAttribute('class', 'lan ' + (harSiffra(v) ? band(v.andel) : 'tom'));
      // ⛔ `aria-label`, INTE `<title>`. Ett `<title>` ger webbläsarens egen
      // tooltip efter ~1 s, och den la sig OVANPÅ hover-utläsningen nedan —
      // samma text två gånger, i två olika stilar. SVG:n byggs helt av den här
      // filen, så `<title>` har ingen roll för en besökare utan JavaScript;
      // då finns ingen karta alls och tabellen är fallbacken. Namnet måste
      // fortsatt uppdateras HÄR vid varje parameterbyte, annars läser en
      // skärmläsare upp järn medan kartan visar uran.
      former[l.n].setAttribute('aria-label', l.n + ' – ' +
        (harSiffra(v)
          ? pct(v.andel) + ' av brunnsproven ' + (p.verb || 'över') + ' riktvärdet för ' + p.namn
          : 'för få brunnsprov för ' + p.namn + ' (' + antal(v.n) + ')'));
      var t = etiketter[l.n];
      if (!t) return;
      if (harSiffra(v)) {
        t.textContent = Math.round(v.andel);
        t.removeAttribute('hidden');
        t.style.display = '';
      } else {
        // Tom text, inte en nolla. En etikett som visar 0 läses som "noll
        // procent av proven", inte som "vi vet inte".
        t.textContent = '';
        t.style.display = 'none';
      }
    });
    if (riktrad) {
      riktrad.innerHTML = 'Visar <strong>' + p.namn + '</strong>. Riktvärde: <strong>' +
        p.riktvarde + '</strong>. ' + lanMed(aktiv) + ' av 21 län har minst ' +
        D.min_prov + ' brunnsprov och får en siffra; övriga är rastrerade.';
    }
  }

  // ── Kartan ──────────────────────────────────────────────────────────────────
  D.lan.forEach(function (l) {
    var g = document.createElementNS(NS, 'g');
    g.setAttribute('class', 'lansform');
    g.setAttribute('tabindex', '0');
    g.setAttribute('role', 'button');

    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', l.d);
    p.setAttribute('class', 'lan tom');
    g.appendChild(p);

    g.addEventListener('click', function () { valj(l.n); });
    g.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); valj(l.n); }
    });

    // ⛔ BARA MUS. `pointerenter` fyrar även på ett finger, och då fastnade
    // utläsningen kvar efter tryckningen – på en telefon finns ingen
    // pointerleave att rensa med. Tryck ska välja länet (click ovan), inte
    // hovra det.
    g.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      // Koordinaterna MÅSTE med redan här. Placerades rutan först vid
      // `pointermove` saknade den left/top vid allra första hovern och ritades
      // i kartrutans hörn — och rullar man med hjulet med stillastående mus
      // fyrar Chromium `pointerenter` UTAN något efterföljande `pointermove`,
      // så texten byttes till det nya länet medan rutan stod kvar på det
      // förras plats.
      hovra(l.n, null, e.clientX, e.clientY);
    });
    g.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      flyttaTip(e.clientX, e.clientY);
    });
    g.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      slutaHovra();
    });
    // Tangentbordsparitet: samma utläsning på fokus, placerad vid länets
    // mittpunkt. Utan den är hover-informationen osynlig för den som tabbar.
    //
    // ⛔ BARA TANGENTBORDSFOKUS. Ett TRYCK på en skärm fokuserar också
    // elementet (`tabindex="0"`), och den vägen kom den klistriga tooltipen
    // tillbaka på mobilen TROTS `pointerType`-guarden ovan — uppmätt på
    // iPhone 13: tooltipen stod kvar efter tryckningen, med ingen
    // pointerleave som kunde rensa den. `pekarnyss` är den enda spärren som
    // håller; ta den inte bort för att "förenkla".
    g.addEventListener('focus', function () {
      if (pekarnyss) return;
      hovra(l.n, l.mitt);
    });
    // ⛔ BARA OM DET ÄR MITT EGET LÄN SOM VISAS. Ett ovillkorligt
    // `slutaHovra()` släckte utläsningen för ett ANNAT län: klicka län A,
    // flytta musen till B (tooltip syns), klicka B — då fyrar `blur` på A,
    // nollade `hovrat`, och eftersom `flyttaTip` bailar på `hovrat === null`
    // kom utläsningen inte tillbaka förrän pekaren lämnade B och gick in igen.
    g.addEventListener('blur', function () {
      if (hovrat === l.n) slutaHovra();
    });
    gLan.appendChild(g);
    former[l.n] = g;

    if (gEtiketter) {
      var t = document.createElementNS(NS, 'text');
      t.setAttribute('class', 'etikett');
      t.setAttribute('x', l.mitt[0]);
      t.setAttribute('y', l.mitt[1] + 5);
      t.setAttribute('text-anchor', 'middle');
      gEtiketter.appendChild(t);
      etiketter[l.n] = t;
    }
  });

  // ── Nyckeltalen ─────────────────────────────────────────────────────────────
  // ⛔ ALLA TAL LÄSES UR `D.riks`. Räkna inget här, och hitta inte på ett
  // sammanvägt mått — "8 av 10 brunnar får anmärkning" kräver per-prov-data
  // som den här filen inte har, och ett påhittat tal är värre än inget.
  // Parametrar vi inte mäter (bakterier, hårdhet, radon) nämns inte alls.
  // ⛔ INTE `nyckel`. Sökrutans normaliseringsfunktion heter redan så, och
  // `var` är funktionsscopad: den deklarationen skrev över elementet här, så
  // `nyckel.innerHTML = …` satte en egenskap på en FUNKTION och nyckeltalen
  // renderades aldrig — utan ett enda felmeddelande.
  var nyckeltalYta = document.getElementById('svp-sgu-nyckeltal');

  function ritaNyckeltal() {
    if (!nyckeltalYta || !D.riks) return;
    var rader = [];
    D.parametrar.forEach(function (p) {
      var r = D.riks[p.namn];
      if (r && typeof r.andel === 'number') {
        rader.push({ namn: p.namn, andel: r.andel, n: r.n, verb: p.verb || 'över' });
      }
    });
    if (!rader.length) return;
    rader.sort(function (a, b) { return b.andel - a.andel; });
    var prov = rader.reduce(function (m, x) { return x.n > m ? x.n : m; }, 0);

    var html = '<div class="sgu-nt stark"><span class="tal">' + pct(rader[0].andel) +
      '</span><span class="txt">av brunnsproven ' + rader[0].verb +
      ' riktvärdet för ' + rader[0].namn + ' – den vanligaste anmärkningen</span></div>';
    rader.slice(1, 3).forEach(function (x) {
      html += '<div class="sgu-nt"><span class="tal">' + pct(x.andel) +
        '</span><span class="txt">' + x.verb + ' riktvärdet för ' + x.namn + '</span></div>';
    });
    html += '<div class="sgu-nt"><span class="tal">' + antal(D.prov_unika) +
      '</span><span class="txt">brunnsprov i materialet, ' + D.period.fran + '–' +
      D.period.till + '</span></div>';
    html += '<p class="sgu-nt-kalla">Källa: SGU:s grundvattenkemi, ' +
      D.parametrar.length + ' parametrar i 21 län. Andelen gäller de prov som ' +
      'analyserats för ämnet (flest: ' + antal(prov) + ' för ' +
      rader.filter(function (x) { return x.n === prov; })[0].namn +
      '), inte alla brunnar i Sverige.</p>';
    nyckeltalYta.innerHTML = html;
  }

  // ── Länsväljaren ────────────────────────────────────────────────────────────
  var lanval = document.getElementById('svp-sgu-lanval');
  if (lanval) {
    var opt = '<option value="">Välj län…</option>';
    D.lan.slice().sort(function (a, b) { return a.n.localeCompare(b.n, 'sv'); })
      .forEach(function (l) { opt += '<option value="' + l.n + '">' + l.n + '</option>'; });
    lanval.innerHTML = opt;
    lanval.addEventListener('change', function () {
      if (lanval.value) valj(lanval.value);
    });
  }

  // ── Topplistan och staplarna ────────────────────────────────────────────────
  // ⭐ X-AXELN ÄR FAST OCH DELAS AV ALLA NIO PARAMETRARNA, av exakt samma skäl
  // som färgskalan: en axel som sträcktes om per parameter hade gett uran
  // (högst 7,4 % i ett län) lika långa staplar som pH (högst 47,1 %), och
  // sidan hade sett lika alarmerande ut för ett ämne som nästan aldrig
  // överskrids. 55 rymmer den högsta ÖVRE osäkerhetsgränsen i materialet
  // (54,3 %). Byts datan ut måste talet mätas om — gör det inte dynamiskt.
  var AXEL = 55;
  var topp = document.getElementById('svp-sgu-topp');
  var staplar = document.getElementById('svp-sgu-staplar');

  function bredd(v) { return Math.max(0, Math.min(100, (v / AXEL) * 100)); }

  // Län med en siffra för parametern, fallande. Län under tröskeln har ingen
  // `andel` i datan och kan därför inte rangordnas — de hamnar sist, utan tal.
  function rankade(p) {
    var med = [];
    var utan = [];
    D.lan.forEach(function (l) {
      var v = varde(l, p);
      if (harSiffra(v)) med.push({ l: l, v: v }); else utan.push({ l: l, v: v });
    });
    med.sort(function (a, b) { return b.v.andel - a.v.andel; });
    utan.sort(function (a, b) { return a.l.n.localeCompare(b.l.n, 'sv'); });
    return { med: med, utan: utan };
  }

  // ⛔ "HÖGST ANDEL", ALDRIG "VÄRST". Tvåan och trean har ofta överlappande
  // osäkerhetsintervall — Nitrat: Gotland 19,6 % (17,1–22,4) och Blekinge
  // 19,3 % (16,2–23,0). En rangordning som påstår mer än datan bär är ett
  // sakfel, och därför skrivs intervallet ut på varje kort.
  function ritaTopp() {
    if (!topp) return;
    var p = parameter(aktiv);
    var r = rankade(aktiv);
    if (r.med.length < 3) { topp.innerHTML = ''; return; }
    var html = '';
    r.med.slice(0, 3).forEach(function (x, i) {
      html += '<button type="button" class="sgu-topp-kort" data-lan="' + x.l.n + '">' +
        '<span class="plats">' + (i + 1) + '. högst andel</span>' +
        '<span class="lan">' + x.l.n + '</span>' +
        '<span class="tal">' + pct(x.v.andel) + '</span>' +
        '<span class="ci">' + pct(x.v.lag).replace(' %', '') + '–' + pct(x.v.hog) + '</span>' +
        '</button>';
    });
    html += '<p class="sgu-topp-not">Högst andel brunnsprov ' + (p.verb || 'över') +
      ' riktvärdet för <strong>' + p.namn + '</strong>, av de ' + r.med.length +
      ' län som har minst ' + D.min_prov + ' prov. Intervallet är osäkerheten — ' +
      'överlappar två län går de inte att skilja åt.</p>';
    topp.innerHTML = html;
  }

  function ritaStaplar() {
    if (!staplar) return;
    var p = parameter(aktiv);
    var r = rankade(aktiv);
    var riks = (D.riks && D.riks[aktiv] && typeof D.riks[aktiv].andel === 'number')
      ? D.riks[aktiv].andel : null;

    var html = '<div class="sgu-st-rubrik"><h3>' + p.namn + ' – alla 21 län</h3>' +
      '<span class="not">Andel brunnsprov ' + (p.verb || 'över') + ' riktvärdet ' +
      p.riktvarde + '. Skalan är 0–' + AXEL + ' % och densamma för alla ' +
      D.parametrar.length + ' parametrarna.</span></div>';

    function rad(x, harTal) {
      var v = x.v;
      var s = '<div class="sgu-st-rad" data-lan="' + x.l.n + '" role="button" tabindex="0">' +
        '<span class="sgu-st-namn">' + x.l.n + '</span>' +
        '<span class="sgu-st-spar' + (harTal ? '' : ' tom') + '">';
      if (harTal) {
        // Osäkerheten ritas som ett band från lag till hog.
        if (typeof v.lag === 'number' && typeof v.hog === 'number') {
          s += '<span class="sgu-st-ci" style="left:' + bredd(v.lag).toFixed(2) +
            '%;width:' + Math.max(0.6, bredd(v.hog) - bredd(v.lag)).toFixed(2) + '%"></span>';
        }
        s += '<span class="sgu-st-bar ' + band(v.andel) + '" style="width:' +
          bredd(v.andel).toFixed(2) + '%"></span>';
      }
      if (riks !== null) {
        s += '<span class="sgu-st-riks" style="left:' + bredd(riks).toFixed(2) +
          '%" title="Riket ' + pct(riks) + '"></span>';
      }
      s += '</span><span class="sgu-st-varde' + (harTal ? '' : ' tunn') + '">' +
        (harTal ? pct(v.andel) : 'för få prov') + '</span></div>';
      return s;
    }

    r.med.forEach(function (x) { html += rad(x, true); });
    // ⛔ LÄNEN UNDER TRÖSKELN MÅSTE MED. Utelämnas de ser sidan ut att ha 18
    // län, och den som bor i Dalarna tror att vi glömt länet i stället för att
    // underlaget är för tunt.
    r.utan.forEach(function (x) { html += rad(x, false); });

    html += '<div class="sgu-st-forklaring">' +
      '<span><i class="pci"></i>osäkerhet (95 %)</span>' +
      (riks !== null ? '<span><i class="priks"></i>riket ' + pct(riks) + '</span>' : '') +
      '<span>Län under ' + D.min_prov + ' brunnsprov får ingen siffra.</span>' +
      '</div>';
    staplar.innerHTML = html;
    markeraStapel();
  }

  function markeraStapel() {
    if (!staplar) return;
    Array.prototype.forEach.call(staplar.querySelectorAll('.sgu-st-rad'), function (d) {
      d.classList.toggle('vald', d.getAttribute('data-lan') === valt);
    });
  }

  if (topp) {
    topp.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-lan]');
      if (b) valj(b.getAttribute('data-lan'));
    });
  }
  if (staplar) {
    staplar.addEventListener('click', function (e) {
      var d = e.target.closest('.sgu-st-rad');
      if (d) valj(d.getAttribute('data-lan'));
    });
    staplar.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var d = e.target.closest('.sgu-st-rad');
      if (d) { e.preventDefault(); valj(d.getAttribute('data-lan')); }
    });
  }

  // ── Hover-utläsningen ───────────────────────────────────────────────────────
  // ⛔ HOVER RÖR ALDRIG `valt` ELLER `kort`. Kortet är det användaren KLICKADE
  // fram; skrev hovern över det raderade varje musrörelse över kartan hens val,
  // och då blir kortet oanvändbart. Hovertillståndet lever bara i `hovrat` och
  // i tooltipen.
  //
  // ⛔ OCH DEN RÄKNAR INGEN ANDEL. Samma regel som filhuvudet: finns ingen
  // `andel` i datan har länet för tunt underlag, och då skrivs "för få prov".
  // Ett `over / n` här hade återinfört precis det tröskeln tog bort.
  var tip = null;
  var hovrat = null;

  // Kom senaste fokus från en pekare eller från tangentbordet? `keydown` för
  // Tab fyrar INNAN fokus flyttas, så flaggan är redan nollad när
  // focus-handlaren läser den. Lyssnarna är i capture-fasen för att hinna
  // före elementets egna.
  var pekarnyss = false;
  document.addEventListener('pointerdown', function () { pekarnyss = true; }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') pekarnyss = false;
  }, true);

  function tipruta() {
    if (tip) return tip;
    var ruta = svg.parentNode;
    if (!ruta || !ruta.classList || !ruta.classList.contains('sgu-kartruta')) return null;
    tip = document.createElement('div');
    tip.id = 'svp-sgu-tip';
    // Utläsningen dubblerar `aria-label` på länet, som skärmläsaren redan
    // läser. Därför gömd för hjälpmedel – annars läses samma text två gånger.
    tip.setAttribute('aria-hidden', 'true');
    ruta.appendChild(tip);
    return tip;
  }

  function hovra(namn, mitt, klientX, klientY) {
    var l = hitta(namn);
    var t = tipruta();
    if (!l || !t) return;
    if (hovrat && former[hovrat]) former[hovrat].classList.remove('hovrad');
    hovrat = namn;
    former[namn].classList.add('hovrad');

    var p = parameter(aktiv);
    var v = varde(l, aktiv);
    var html = '<strong>' + l.n + '</strong>';
    if (harSiffra(v)) {
      html += '<span class="tal">' + pct(v.andel) + '</span> ' +
        (p.verb || 'över') + ' riktvärdet för ' + p.namn +
        '<br><span class="svagt">' + pct(v.lag).replace(' %', '') + '–' + pct(v.hog) +
        ' · ' + antal(v.n) + ' brunnsprov</span>';
    } else {
      html += 'För få brunnsprov för ' + p.namn +
        '<br><span class="svagt">' + antal(v.n) + ' prov, under ' + D.min_prov +
        ' · ingen siffra visas</span>';
    }
    t.innerHTML = html;
    t.classList.add('syns');

    // Placera ALLTID. Fokusvägen har ingen pekare och använder länets
    // mittpunkt; musvägen skickar med sina koordinater redan vid
    // `pointerenter`. Utan det ritas rutan utan left/top vid första hovern.
    if (typeof klientX === 'number' && typeof klientY === 'number') {
      placera(klientX, klientY);
    } else if (mitt) {
      var r = svg.getBoundingClientRect();
      placera(
        r.left + (mitt[0] / D.bredd) * r.width,
        r.top + (mitt[1] / D.hojd) * r.height
      );
    }
  }

  function flyttaTip(x, y) { if (hovrat) placera(x, y); }

  // Klampar inom kartrutan. Utan klampningen stack tooltipen ut till höger om
  // kartan vid Norrbotten och gav vågrät scroll på telefon i liggande läge.
  function placera(klientX, klientY) {
    var t = tipruta();
    if (!t) return;
    var ruta = t.parentNode.getBoundingClientRect();
    var b = t.offsetWidth || 220;
    var h = t.offsetHeight || 60;
    var x = klientX - ruta.left + 14;
    var y = klientY - ruta.top - h - 12;
    if (x + b > ruta.width - 4) x = klientX - ruta.left - b - 14;
    if (x < 4) x = 4;
    if (y < 4) y = klientY - ruta.top + 18;
    if (y + h > ruta.height - 4) y = Math.max(4, ruta.height - h - 4);
    t.style.left = Math.round(x) + 'px';
    t.style.top = Math.round(y) + 'px';
  }

  function slutaHovra() {
    if (hovrat && former[hovrat]) former[hovrat].classList.remove('hovrad');
    hovrat = null;
    if (tip) tip.classList.remove('syns');
  }

  // ── Faktakortet ─────────────────────────────────────────────────────────────
  function tomtKort() {
    kort.innerHTML = '<p class="valj">Välj ett län i kartan, eller sök på ' +
      'länets namn, för att se hur SGU:s brunnsprov därifrån har fallit ut ' +
      '— för alla ' + D.parametrar.length + ' parametrarna.</p>';
  }

  function valj(namn) {
    var l = hitta(namn);
    if (!l) return;
    valt = namn;
    Object.keys(former).forEach(function (n) {
      former[n].classList.toggle('vald', n === namn);
    });
    var p = parameter(aktiv);
    var v = varde(l, aktiv);
    var html = '<h3>' + l.n + '</h3>';
    if (harSiffra(v)) {
      html += '<p class="stor">' + pct(v.andel) + '</p>' +
        '<p class="bandnamn"><span class="prick ' + band(v.andel) + '"></span>' +
        'av brunnsproven ' + (p.verb || 'över') + ' riktvärdet för ' + p.namn + '</p>' +
        '<dl class="fakta">' +
        '<dt>Riktvärde</dt><dd>' + p.riktvarde + '</dd>' +
        '<dt>Osäkerhet</dt><dd>' + pct(v.lag).replace(' %', '') + '–' + pct(v.hog) +
        ' <span class="svagt">(95 % säkerhet)</span></dd>' +
        '<dt>Brunnsprov</dt><dd>' + antal(v.n) + '</dd>' +
        '</dl>';
    } else {
      // Ingen siffra finns i datan, och ingen räknas fram här.
      html += '<p class="stor tunn">För få prov</p>' +
        '<p class="rad">SGU har ' + antal(v.n) + ' brunnsprov för ' + p.namn + ' i ' + l.n +
        ', och under ' + D.min_prov + ' blir osäkerheten bredare än talet är värt. ' +
        'Därför visas ingen andel.</p>';
    }

    // Hela länet på en gång — det är den här listan som är kortets verkliga
    // nytta. En besökare vill veta vad som finns i sitt län, inte klicka sig
    // genom nio parametrar.
    html += '<p class="allarubrik">Alla parametrar i ' + l.n + '</p><ul class="sgu-alla">';
    D.parametrar.forEach(function (q) {
      var w = varde(l, q.namn);
      html += '<li' + (q.namn === aktiv ? ' class="nu"' : '') +
        '><button type="button" data-param="' + q.namn + '">' + q.namn +
        '<span>' + (harSiffra(w) ? pct(w.andel) : 'för få prov') + '</span></button></li>';
    });
    html += '</ul>';
    html += '<p class="rad"><a href="/collections/vattenanalys">Se vad som finns i din egen brunn →</a></p>';
    kort.innerHTML = html;
    markeraStapel();
    // Håll <select> i takt med kartan: väljer man via kartan, tabellen eller
    // sökrutan ska dropdownen visa samma län, annars pekar de åt olika håll.
    if (lanval && lanval.value !== namn) lanval.value = namn;
  }

  // Klick på en parameter inne i kortet byter parameter. Delegerat på `kort`,
  // inte bundet per knapp — kortets innehåll byts ut vid varje val, så en
  // lyssnare per knapp hade försvunnit med den gamla HTML:en.
  kort.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-param]');
    if (b) valjParameter(b.getAttribute('data-param'));
  });

  // ── Sökrutan ────────────────────────────────────────────────────────────────
  if (sok && traffar) {
    // Skiftlägesokänsligt, och okänsligt för att man skriver "lan" utan prickar.
    var nyckel = function (s) {
      return String(s).toLowerCase()
        .replace(/[åä]/g, 'a').replace(/ö/g, 'o').replace(/\s+/g, ' ').trim();
    };
    sok.addEventListener('input', function () {
      var q = nyckel(sok.value);
      if (!q) { traffar.hidden = true; traffar.innerHTML = ''; return; }
      var tr = D.lan.filter(function (l) { return nyckel(l.n).indexOf(q) >= 0; });
      if (!tr.length) {
        traffar.innerHTML = '<p class="ingen">Inget län matchar “' +
          sok.value.replace(/[<>&]/g, '') + '”.</p>';
      } else {
        traffar.innerHTML = tr.map(function (l) {
          var v = varde(l, aktiv);
          return '<button type="button" data-lan="' + l.n + '">' + l.n +
            '<span>' + (harSiffra(v) ? pct(v.andel) : 'för få prov') + '</span></button>';
        }).join('');
      }
      traffar.hidden = false;
    });
    traffar.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-lan]');
      if (!b) return;
      valj(b.getAttribute('data-lan'));
      traffar.hidden = true;
      sok.value = b.getAttribute('data-lan');
      var f = former[b.getAttribute('data-lan')];
      if (f && f.scrollIntoView) f.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  }

  // ── HTML-tabellen ───────────────────────────────────────────────────────────
  // Raderna pekar på samma län som kartan, och den valda parameterns kolumn
  // markeras. Utan kopplingen är tabellen och kartan två saker som inte vet
  // om varandra.
  var tabell = document.querySelector('.svp-lans-tabell--sgu');
  function markeraKolumn() {
    if (!tabell) return;
    var i = -1;
    D.parametrar.forEach(function (p, k) { if (p.namn === aktiv) i = k; });
    Array.prototype.forEach.call(tabell.querySelectorAll('tr'), function (rad) {
      Array.prototype.forEach.call(rad.children, function (cell, k) {
        // Första cellen är länsnamnet, därför k - 1.
        cell.classList.toggle('kolumn-nu', k - 1 === i);
      });
    });
  }
  if (tabell) {
    tabell.addEventListener('click', function (e) {
      var rad = e.target.closest('tr[id^="lan-"]');
      if (!rad) return;
      var th = rad.querySelector('th');
      if (!th) return;
      valj(th.textContent.trim());
      if (yta.scrollIntoView) yta.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    tabell.classList.add('klickbar');
  }

  // Skyddsnät: lämnar pekaren hela kartan utan att ett läns `pointerleave`
  // hann fyra (snabb rörelse ut över kanten, eller ett fönsterbyte) står
  // tooltipen annars kvar och pekar på ingenting.
  svg.addEventListener('pointerleave', function (e) {
    if (e.pointerType !== 'mouse') return;
    slutaHovra();
  });

  ritaNyckeltal();
  tomtKort();
  valjParameter(aktiv);
}());
